import {
  getExcludedKeywords,
  deleteExcludedKeyword,
  addExcludedKeyword,
} from "../../../api/divvy-excludedKeywords";

const excludedKeywords = {
  namespaced: true,
  state: () => ({
    getExcludedKeywordsData: null,
    selectedKeywords: [],
  }),

  getters: {
    getExcludedKeywordsData: (state) => {
      return state.getExcludedKeywordsData;
    },
    getSelectedKeywords: (state) => {
      return state.selectedKeywords;
    },
  },

  actions: {
    getExcludedKeywords({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getExcludedKeywords(payload)
          .then((res) => {
            resolve(res);
            commit("SET_EXCLUDED_KEYWORDS_DATA", res);
          })
          .catch((err) => {
            console.log("getExcludedKeywords store", err);
          });
      });
    },

    deleteExcludedKeyword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        deleteExcludedKeyword(payload)
          .then((res) => {
            resolve(res);
            commit("SET_SELECTED_KEYWORDS", []);
          })
          .catch((err) => {
            console.log("deleteExcludedKeyword store", err);
          });
      });
    },

    addExcludedKeyword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        addExcludedKeyword(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            console.log("addExcludedKeyword store", err);
          });
      });
    },
  },

  mutations: {
    SET_EXCLUDED_KEYWORDS_DATA: (state, res) => {
      state.getExcludedKeywordsData = res;
    },
    SET_SELECTED_KEYWORDS: (state, data) => {
      state.selectedKeywords = data;
    },
  },
};

export default excludedKeywords;
